<template>
  <v-dialog persistent :value="brandingModal"  width="800">
    <resource-picker-popup :resourceSelected="selectBrandingLogo"></resource-picker-popup>
    <v-card >
      <popup-heading 
      title="BRANDING A BUSINESS" 
      subtitle="Brand your Business.">
        <template slot="action">
          <v-btn
            depressed
            @click="closeModal()"
            fab 
            color="white"
            :class="$vuetify.breakpoint.width > 960 ? 'ml-0 mr-2' : 'ml-2'"
          >
            <v-icon dark class="primary--text">close</v-icon>
          </v-btn>

          <v-btn
            depressed
            v-if="loaded"
            @click="existingBranding ? updateBranding() : addNewBranding()"
            fab 
            color="white"
            :class="$vuetify.breakpoint.width > 960 ? 'ml-0 mr-0' : 'ml-0'"
          >
            <v-icon dark class="primary--text">check</v-icon>
          </v-btn>
        </template>
      </popup-heading>

      <v-flex class="sm12 md12 lg12">
        <v-card-text class="pb-5 px-5"  v-if="loaded">
          <v-flex sm12 md12 class="text-left">
            <img  class="display-img" :src="form.logo" alt="" v-if="form.logo"/>
          </v-flex>
          <div class="text-left mb-5">
            <v-btn
              depressed 
              class="ml-0" 
              color="primary" 
              @click.prevent="openAttachmentPopup()">
              <v-icon dark left>fas fa-image</v-icon>{{ form.logo == '' ? 'add image' : 'update image'}}
            </v-btn>
          </div>
          <color-picker label="Primary Colour" :color="form.brand_colors.primary" v-model="form.brand_colors.primary"></color-picker>
          <color-picker label="Secondary Colour" :color="form.brand_colors.secondary" v-model="form.brand_colors.secondary"></color-picker>
          <color-picker label="Accent Colour" :color="form.brand_colors.accent" v-model="form.brand_colors.accent"></color-picker>
        </v-card-text>
        <v-card-text class="pb-5 px-5" v-else>
          <block-spinner></block-spinner>
        </v-card-text>
      </v-flex>
    
    </v-card>
  </v-dialog>
</template>
<script>
import UnoappResourcePicker from '@/plugins/unoapp-resource-picker/app.resource.picker';
import Env from '@/env';
import AuthApi from '@/components/Controllers/AuthApis';
import Helper from '@/components/Controllers/Helpers';
import { mapActions, mapGetters } from 'vuex';
import { isEmpty } from 'lodash';
import { Chrome } from 'vue-color'

export default {
  components: {
    'chrome-picker': Chrome,
    UnoappResourcePicker,
  },
  data() {
    return {
      loaded: false,
      fieldRequired: [
        v => !!v || 'Field is required.',
      ],
      existingBranding: false,
      form: {
        logo: '',
        brand_colors: {
          primary: '',
          secondary: '',
          accent: '',
        },
      },
    };
  },
  computed: {
    ...mapGetters({
      brandingModal: 'business/branding',
      brandingObj: 'business/brandingObj',
      attachmentData: 'attachment/data',
    }),
  },
  mounted() {
    this.closeModal();
  },
  watch: {
    brandingObj(obj) {
      if (!_.isEmpty(obj)) {
        this.getBusinessBranding(obj.id);
      }
    },
  },
  methods: {
  
    selectBrandingLogo(resources) {  
      this.form.logo = resources[0].full_url;
      this.setAttachmentPopup(false);
    },

    /**
     * Open attachment 
     */
    openAttachmentPopup() {
      this.setAttachmentPopup(true);
    },

    /**
     * Get branding for current business
     */
    getBusinessBranding(id) {
      this.loaded = false;
      this.spinner(true);
      const url = `${Env.url}/api/v1/businesses/${id}`;
      AuthApi.getApi(url)
        .then((res) => {
          this.existingBranding = true;
          this.loaded = true;
          this.spinner(false);
           if (res.data.payload.branding) {
            this.form.logo = res.data.payload.branding.logo;
            if(res.data.payload.branding.brand_colors != '') {
               this.form.brand_colors = res.data.payload.branding.brand_colors;
            }
           } else {
             console.log('No branding.')
           }
        })
        .catch(err => {
          this.existingBranding = false;
          this.loaded = true;
          this.spinner(false);
          console.log( err)
        })
    },
    
    /**
     * Add new branding
     */
    addNewBranding() {
      this.spinner(true);
      const url = `${Env.url}/api/v1/businesses/${this.brandingObj.id}/branding `;
      AuthApi.postApi(url, this.form)
        .then((res) => {
          this.spinner(false);
          this.snackbar({
            text: res.data.msg,
            timeout: 4000,
            open: true,
          });
          this.getUpdatedBusinessBranding();
          this.closeModal();
        })
        .catch((err) => {
            this.snackbar({
            text: err.response.data.msg ? err.response.data.msg : 'Please try again later.',
            timeout: 4000,
            open: true,
          });
          this.spinner(false);
        });
    },

    /**
     * Update branding
     */
    updateBranding() {
      this.spinner(true);
      const url = `${Env.url}/api/v1/businesses/${this.brandingObj.id}/branding`;
      AuthApi.patchApi(url, this.form)
        .then((res) => {
          this.spinner(false);
          this.snackbar({
            text: res.data.msg,
            timeout: 4000,
            open: true,
          });
          this.getUpdatedBusinessBranding();
          this.closeModal();
        })
        .catch((err) => {
            this.snackbar({
            text: err.response.data.msg ? err.response.data.msg : 'Please try again later.',
            timeout: 4000,
            open: true,
          });
          this.spinner(false);
        });
    },

    /**
     * Fetch business branding
     */
    getUpdatedBusinessBranding() {
      const url = `${Env.url}/api/v1/businesses/${this.$store.getters.getLoggedInUserSelectedBusinessId}`;
      AuthApi.getApi(url)
        .then((res) => {
          this.$vuetify.theme.themes.light.primary = res.data.payload.branding.brand_colors.primary;
          this.$vuetify.theme.themes.light.secondary = res.data.payload.branding.brand_colors.secondary;
          this.$vuetify.theme.themes.light.accent = res.data.payload.branding.brand_colors.accent;
          this.$store.dispatch('SET_USER_SELECTED_ACCOUNT_BRANDING', res.data.payload.branding);  
        })
        .catch(err => {
          console.log( err)
        })
    },

    /**
     * Close update modal and remove assign values in form
     */
    closeModal() {
      // Rest form values
      this.form.logo = '';
      this.form.brand_colors = {
        primary: '',
        secondary: '',
        accent: '',
      };
      this.loaded = false;
      this.setBranding(false);
      this.setBrandingObj({});
    },
    
    ...mapActions({
      setBranding: 'business/setBranding',
      setBrandingObj: 'business/setBrandingObj',
      setAttachmentPopup: 'attachment/setActive',
      setAttachmentData: 'attachment/setData',
      spinner: 'spinner/spinnerStatus',
      snackbar: 'snackbar/snackbar',
    }),
  },
};
</script>
